import {makeActionCreator, makeActionType, getActionType} from '../util/redux';
import Request from '../util/fetch';

export const ResourceType = 'resource';

makeActionType(ResourceType, ['tasksuccess', 'taskfail', 'whitelistsuccess', 'whitelistfail', 'resourceuse']);

export const resourceSuccess = makeActionCreator(getActionType(ResourceType, 'success'));
export const resourceFail = makeActionCreator(getActionType(ResourceType, 'fail'));
export const taskSuccess = makeActionCreator(getActionType(ResourceType, 'tasksuccess'));
export const taskFail = makeActionCreator(getActionType(ResourceType, 'taskfail'));
export const whiteListSuccess = makeActionCreator(getActionType(ResourceType, 'whitelistsuccess'));
export const whiteListFail = makeActionCreator(getActionType(ResourceType, 'whitelistfail'));
export const resourceUse = makeActionCreator(getActionType(ResourceType, 'resourceuse'));


export const resourceRequest = (data) => (dispatch) =>{
    return Request.fetch({
        url: 'api/cloudvideo/app/promotion/resource/list',
    }).then(res => {
        dispatch(resourceSuccess(res));
    }).catch(err => {
        let rerr = Request.resolveError(err);
        dispatch(resourceFail(rerr));
    })
}

export const taskRequest = (data) => (dispatch) =>{
    return Request.fetch({
        url: 'api/cloudvideo/promotion/task',
    }).then(res => {
        dispatch(taskSuccess(res));
    }).catch(err => {
        let rerr = Request.resolveError(err);
        dispatch(taskFail(rerr));
    })
}

export const whiteListRequest = (data) => (dispatch) => {
    return Request.fetch({
        url: 'api/cloudvideo/app/promotion/privilege'
    }).then(res => {
        dispatch(whiteListSuccess(res));
    }).catch(err => {
        let rerr = Request.resolveError(err);
        dispatch(whiteListFail(rerr));
    })
}





// WEBPACK FOOTER //
// ./client/action/resource.js